import { matchWriteFailure } from "../Tabs/Matches/matchWriteText"
import { entryKeys, participantKey, placedKeys } from "./participantIdentity"

export const isEmptyBye = entry =>
  (entry?.type === "BYE" || entry?.placeholder === "BYE") && entry?.userId == null

// A Main List entry that takes a group's BYE position takes it in all its matches at once.
// When an earlier replacement filled only some of them, the entry is already in that group;
// it may still complete a BYE match against a side it has not met yet. Its people by participant
// key: a Tenis10 child, never its sibling under the same parent account (PRD 16 LR11c).
export const completesGroupBye = (entry, { matches = [], match, role }) => {
  const competition = match?.competition
  if (competition?.drawType !== "groups" || competition?.phaseId || !isEmptyBye(match?.[role])) return false
  const team = entryKeys(entry)
  const placed = matches.flat(Infinity).filter(row => placedKeys([row]).some(key => team.includes(key)))
  if (!placed.length) return false
  const sameGroup = placed.every(({ competition: other }) =>
    other?.drawType === "groups" && !other?.phaseId && other?.group === competition.group)
  const facing = participantKey(match[role === "player" ? "opponent" : "player"])
  return sameGroup && (facing == null || !placed.some(row => placedKeys([row]).includes(facing)))
}

// Replacement refusals arrive on `matches-response` like every other match write.
export const replacementErrorMessage = matchWriteFailure
